import { Input, Select } from "antd";
import React from "react";

const AddDetails = (props) => {
    const { customData, onChangeName, menuGroups, onMenuGroupChange, menuItems, onChangeCustomise,
         isCustomised, onMenuExcepChange, onMenuItemChange, onMenuChange, menuDetails } = props;
    let filteredData = menuGroups?.menu_groups?.filter((grp)=> grp.id === customData.menu_group_id)[0];
    let menuFilterData = menuDetails?.menus?.filter((grp)=> grp.id === customData.menu_id)[0];
    const getValueFromList = (arr) => {
       let idList = arr?.map((ids)=> ids?.menu_item_id);
       let values=[];
       menuItems?.menu_items?.menu_items.map((itemList)=>{
        if(idList?.indexOf(itemList.id) > -1) {
            values.push({label:itemList.name, value: itemList.id})
        }
        return null;
       })
       return values;
    };
    return <div className="details_card">
    <div className="header_sec">
        <h2 className="heading">Add Details</h2>
        <div className="sub_head">
            <label>Apply customisation to all items: </label>
            <div className="action_butn">
                <div className={isCustomised ? "selected" : "unselected"} onClick={()=>{ onChangeCustomise(true) }}>Yes</div>
                <div className={!isCustomised ? "selected" : "unselected"} onClick={()=>{ onChangeCustomise(false) }}>No</div>
            </div>
        </div>
    </div>
    <div className="content_sec">
        {!isCustomised  && <>
            <div className="sections">
                <label>Menus</label>
                <Select 
                    placeholder="Select Menu here" 
                    options={menuDetails?.menus?.map((menu)=>({label:menu.name, value: menu.id}))}
                    onChange={onMenuChange}
                    value={menuFilterData ? {label: menuFilterData.name, value: menuFilterData.id}  : null}
                />
            </div>
            <div className="sections">
                <label>Menu Section</label>
                <Select 
                    placeholder="Select Menu Section here" 
                    options={menuGroups?.menu_groups?.map((menu)=>({label:menu.name, value: menu.id}))}
                    onChange={onMenuGroupChange}
                    value={filteredData ? {label:filteredData.name, value:filteredData.id} : null}
                />
            </div>
            <div className="sections">
                <label>Menu Item</label>
                <Select 
                    placeholder="Select Menu Items here" 
                    options={menuItems?.menu_items?.menu_items?.map((menu)=>({label:menu.name, value: menu.id}))}
                    mode="multiple"
                    onChange={onMenuItemChange}
                    value={getValueFromList(customData.menu_customization_menu_items)}
                />
            </div>
        </>}
        <div className="sections">
            <label>Name</label>
            <Input placeholder="Enter Name here" name="name" value={customData.name} onChange={(e)=>{ onChangeName(e) }}/>
        </div>
        {!isCustomised && <div className="sections">
            <label>Exceptions</label>
            <Select 
                placeholder="Select Menu Items here"
                options={menuItems?.menu_items?.menu_items?.map((menu)=>({label:menu.name, value: menu.id}))}
                mode="multiple"
                onChange={onMenuExcepChange}
                value={getValueFromList(customData.menu_customization_exceptions)}
             />
        </div>}
    </div>
    </div>
};
export default AddDetails;